import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, User, LogOut, Home, Info, HelpCircle, FileText, MessageCircle, Phone } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const AdminHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [userType, setUsertype] = useState(0); 
  
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const navLinks = [
    // { path: '/', label: 'Home', icon: Home }
    // { path: '/about', label: 'About Us', icon: Info },
    // { path: '/how-it-works', label: 'How It Works', icon: HelpCircle },
    // { path: '/documents', label: 'Documents', icon: FileText },
    // { path: '/faq', label: 'FAQs', icon: MessageCircle },
    // { path: '/contact', label: 'Contact', icon: Phone },
  ];

  const redernavbar= () => {
    console.log(user?.role_id);
    if(!isAuthenticated){
      return (
        <></>
      )
    }
    switch(user?.role_id){
        case '0':
          return (
            <Link 
            to={`/customer`}
            className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors duration-200"
            onClick={() => setIsMenuOpen(false)}
          >
            <User size={18} className="mr-3" />
            Dashboard
          </Link>
          );
        case 'admin':
          return (
            <Link 
            to={`/admin`}
            className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors duration-200"
            onClick={() => setIsMenuOpen(false)}
          >
            <User size={18} className="mr-3" />
            Dashboard
           </Link>
          );
        default:
          return (
            <Link 
            to={`/approval-dashboard`}
            className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors duration-200"
            onClick={() => setIsMenuOpen(false)}
          >
            <User size={18} className="mr-3" />
            Dashboard
          </Link>
          );
    }




  }
  
  return (
    <header 
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-sm shadow-lg' 
          : 'bg-white shadow-md'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link 
            to="/" 
            className="text-xl font-bold text-blue-600 hover:text-blue-700 transition-colors duration-200"
          >
            Digital Building Approval
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  location.pathname === path
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                {label}
              </Link>
            ))}
            
            {isAuthenticated ? (
              <div className="relative group ml-2">
                <button className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200">
                  <User size={18} />
                  <span>{user?.name || 'User'}</span>
                </button>
                <div className="absolute right-0 w-48 mt-2 origin-top-right bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 border border-gray-100">
                  <div className="py-1">
                  
                   {redernavbar()}

                    <button 
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200"
                    >
                      <LogOut size={16} className="mr-2" />
                      Logout
                    </button>
                    
                  </div>
                </div>
              </div>
            ) : (
              <Link 
                to="/login" 
                className="ml-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors duration-200 shadow-sm hover:shadow"
              >
                Login
              </Link>
            )}
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors duration-200"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {/* Mobile Navigation */}
        <div className={`lg:hidden transition-all duration-300 ${
          isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        } overflow-hidden`}>
          <nav className="py-4 space-y-1">
            {navLinks.map(({ path, label, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  location.pathname === path
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                <Icon size={18} className="mr-3" />
                {label}
              </Link>
            ))}
            
            {isAuthenticated ? (
              <>
                {redernavbar()}
                <button 
                  onClick={() => {
                    handleLogout();
                    setIsMenuOpen(false);
                  }}
                  className="flex items-center w-full px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors duration-200"
                >
                  <LogOut size={18} className="mr-3" />
                  Logout
                </button>
              </>
            ) : (
              <Link 
                to="/login" 
                className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                <User size={18} className="mr-3" />
                Login
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;